import React from 'react';
import './GenericDialogComponent.css';
import { useDialogStore, DialogOption } from '../../store/dialogStore';
import { useTranslation } from 'react-i18next';

const GenericDialogComponent = () => {
    const { t } = useTranslation();
    const { isOpen, position, titleTranslationKey, textTranslationKey, options, hideDialog } = useDialogStore();

    if (!isOpen) {
        return null;
    }

    const handleOptionClick = (option: DialogOption) => {
        option.optionFunction();
        hideDialog();
    };

    return (
        <div
            className="dialog-container"
            style={{ left: position.x, top: position.y }}
        >
            {titleTranslationKey && (
                <div className="dialog-title">{t(titleTranslationKey)}</div>
            )}
            {textTranslationKey && (
                <div className="dialog-text">{t(textTranslationKey)}</div>
            )}
            <div className="dialog-options">
                {options.map((option, index) => (
                    <button
                        key={index}
                        className="dialog-option-button"
                        style={option.optionColor ? { backgroundColor: option.optionColor } : undefined}
                        onClick={() => handleOptionClick(option)}
                    >
                        {t(option.optionNameTranslationKey)}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default GenericDialogComponent;
